module.exports = __webpack_public_path__ + "img/portrait-placeholder.4788048f.png";